export const themes = [
  "functional-minimalism",
  "rose-pine-moon",
  "cybernetic-minimalism"
] as const;

export type ThemeId = (typeof themes)[number];

export const themeMeta: Record<ThemeId, { label: string; description: string }> = {
  "cybernetic-minimalism": {
    label: "Night Chorus",
    description: "Neon wolf command deck"
  },
  "functional-minimalism": { label: "Frost Trail", description: "Clean daylight tracking" },
  "rose-pine-moon": { label: "Moon Howl", description: "Twilight analytical calm" }
};

export type UserBubblePhysics = {
  stiffness: number;
  damping: number;
  mass: number;
  hoverLift: number;
  hoverScale: number;
  tapScale: number;
};

export const userBubblePhysicsByTheme: Record<ThemeId, UserBubblePhysics> = {
  "cybernetic-minimalism": {
    stiffness: 390,
    damping: 31,
    mass: 0.82,
    hoverLift: -2.5,
    hoverScale: 1.012,
    tapScale: 0.994
  },
  "functional-minimalism": {
    stiffness: 320,
    damping: 28,
    mass: 0.9,
    hoverLift: -1.5,
    hoverScale: 1.008,
    tapScale: 0.996
  },
  "rose-pine-moon": {
    stiffness: 240,
    damping: 23,
    mass: 1.05,
    hoverLift: -2,
    hoverScale: 1.01,
    tapScale: 0.995
  }
};
